import { isNull } from 'lodash';
import React, { useRef } from 'react';
import { SliderInput } from '@meitu/saas-ui';
import LabelAction from '@meitu/saas-editor-ui/es/components/label-action';
import { useListenActivePickLayerProps } from '@meitu/saas-editor-ui/es/hooks/use-listen-layer-props';
import { useLocaleStore } from '@/i18n';
import { editor } from '@/instance';

export const OpacityFeature: React.FC<{
    id: string;
    onAfterChange?: Function;
}> = React.memo(({ id, onAfterChange }) => {
    const { $t } = useLocaleStore();
    const originOpacity = useRef<number | null>(null);

    const opacity = useListenActivePickLayerProps(editor, (layer) => {
        if (!layer) return null;
        return layer.opacity;
    });

    if (isNull(opacity)) return null;

    return (
        <div className="c-brush-panel__item opacity  blod" style={{ marginBottom: 16 }}>
            <LabelAction title={$t((v) => v.panel.brushPanel.opacity)} align={true}>
                <SliderInput
                    value={+(opacity * 100).toFixed(0)}
                    max={100}
                    min={0}
                    showStepBtn={true}
                    type="horizontal"
                    onChange={(val: number) => {
                        val = val / 100;
                        if (originOpacity.current === null) {
                            originOpacity.current = opacity;
                        }
                        editor.brushLayer.setOpacity(id, val);
                    }}
                    onAfterChange={(val: number) => {
                        val = val / 100;
                        editor.brushLayer.setOpacity(id, val, originOpacity.current);
                        originOpacity.current = null;
                        onAfterChange?.(21);
                    }}
                />
            </LabelAction>
        </div>
    );
});
